import { createContext } from 'react';

const ProfileDataContext = createContext(0);

export default ProfileDataContext;